import closeIcon from "@/images/close.svg";
import Label from "@/components/label/label.tsx";
import {TranslationKeys} from "@/contexts/TranslationKeys.ts";
import {Field, useFormikContext} from "formik";
import List from "@/components/list/list2.tsx";
import React, {useEffect} from "react";
import Modal from "react-modal";
import {useLocale} from "@/contexts/localeContext.tsx";

interface ChooseModel {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    title: string;
    subtitle: string;
    getCommonNames: () => void;
    rowSelect: (item: any) => void;
    listItems: any[];
}

const ChooseModal: React.FC<ChooseModel> = ({ isOpen, setIsOpen, title, subtitle, getCommonNames, rowSelect, listItems }) => {
    const { errors, values } = useFormikContext<any>();
    const { translate } = useLocale();

    return <Modal isOpen={isOpen}
                  ariaHideApp={false}
                  overlayClassName={`flex w-screen position-float-modal fixed top-0 left-0 h-screen bg-opacity-75 bg-white`}
                  className={`bg-white border-none m-auto shadow select-none outline-none w-content`}>
        <div className={`w-full p-2 border-b flex flex-row items-center bg-sidemenu-focus text-white justify-between`}>
            <div className="flex flex-row">
                <p className="pl-3 font-bold font text-white">{title}</p>
            </div>
            <img src={closeIcon} data-testid="modal_closeLicense" onClick={() => setIsOpen(false)} className="cursor-pointer mr-2" />
        </div>
        <div className="p-2 flex flex-col" style={{ width: '350px', height: '400px' }}>
            <div className="flex flex-col h-full">
                <div className="flex flex-row justify-between" id='searchByCnId'>
                    <Label htmlFor="searchByCn" className="text-xs text-gray-600 mt-1" required>{subtitle}:</Label>
                    {errors.searchByCn ? <span className='text-red-600 text-xs'>{errors.searchByCn}</span> : null}
                </div>
                <div className="flex flex-row w-full space-x-2 mb-2">
                    <Field
                        id='searchByCnId'
                        name='searchByCn'
                        type="text"
                        className="flex flex-row items-center p-1 text-gray-800 text-sm w-full bg-gray-input" />
                    <button type="button" className={`px-4 py-1 w-fit rounded-md shadow text-white text-sm ${values.searchByCn ? 'bg-sidemenu-focus' : 'bg-gray-600 cursor-not-allowed'}`} onClick={() => getCommonNames()} disabled={!values.searchByCn}>
                        {translate.byKey(TranslationKeys.search)}
                    </button>
                </div>
                <div className="flex flex-col h-full" style={{ maxHeight: '80%' }}>
                    <Label htmlFor="foundMatches" className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.foundMatches)}:</Label>
                    <div className="overflow-y-auto flex-1">
                        <List
                            onSelect={(_, item) => rowSelect(item)}
                            isStriped
                            items={listItems}
                            stripedListItemClassName="p-1 pl-3"
                            selectedListItemClassName="p-1 pl-1-5 border-l-7 border-portal-blue-primary bg-selection-highlight border-t-selection-highlight border-r-selection-highlight border-b-selection-highlight" />
                    </div>
                </div>
            </div>
        </div>
    </Modal>
}

export default ChooseModal;
